module.exports = __webpack_public_path__ + "static/media/friends-image.cfea27a0.png";